<template>
  <module-box
    type="fight-info"
    :mode="mode"
    :moduleData="moduleData"
    showSetup
    @onAdd="handleAddModule"
    @onSetup="handleOpenModuleSetupPanel"
    @onDelete="handleDeleteModule"
    @onMore="handleMore"
  >
    <div class="fight-info">
      <module-title :mode="mode" :title="moduleData.title" @onChange="handleTitleChange">
        <template #right>
          <div class="level" v-if="!moduleData.isHideLevelSwitch">
            <level-switch
              :mode="mode"
              :currentLevelData="currentLevelData"
              :data="moduleData.levelList"
              :label="moduleData.label"
              @onAddLevel="handleAddLevel"
              @onChangeLevel="handleChangeLevelItem"
              @onChangeLabel="handleChangeLabel"
              @onPrev="handlePrevLevel"
              @onNext="handleNextLevel"
              @onEdit="handleEditLevel"
              @onDelete="handleDeleteLevel"
              @onChange="handleChangeLevel"
            ></level-switch>
          </div>
        </template>
      </module-title>
      <draggable
        class="container"
        v-model="levelInfoList"
        :animation="200"
        :group="'fightInfoLevelInfoList'"
        :disabled="mode !== 'edit'"
        :ghostClass="'ghost'"
        :handle="'.edit-drag'"
        @start="dragLevelInfo = true"
        @end="dragLevelInfo = false"
        @change="handleSortLevelInfo"
      >
        <template
          v-if="currentLevelData && currentLevelData.levelInfoList && currentLevelData.levelInfoList.length > 0"
        >
          <div class="item-box" v-for="(data, index) in currentLevelData.levelInfoList" :key="data.key">
            <info-box
              :mode="mode"
              :data="data"
              @onAdd="handleAddInfo(index)"
              @onDelete="handleDeleteInfo(index)"
              @onChange="data => handleLevelInfoChange(index, data)"
            ></info-box>
          </div>
        </template>
        <template v-else-if="mode == 'edit'">
          <button class="add-btn" @click.stop="handleAddInfo">
            <i class="icon wiki-editable-add"></i>
          </button>
        </template>
      </draggable>
    </div>
    <!-- 设置 -->
    <setup-panel v-if="mode === 'edit'" ref="setupPanel" :data="moduleData" @onChange="handleChangeData"></setup-panel>
  </module-box>
</template>

<script>
import draggable from "vuedraggable";
// components
import ModuleBox from "../../components/ModuleBox";
import InfoBox from "./components/InfoBox";
import LevelSwitch from "./components/LevelSwitch";
import ModuleTitle from "../../components/ModuleTitle";
import SetupPanel from "./SetupPanel";

export default {
  name: "FightInfo",
  components: {
    draggable,
    ModuleBox,
    InfoBox,
    LevelSwitch,
    ModuleTitle,
    SetupPanel
  },
  props: {
    mode: String,
    moduleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentLevelIndex: 0,
      levelInfoList: []
    };
  },
  computed: {
    currentLevelData() {
      return this.moduleData.levelList ? this.moduleData.levelList[this.currentLevelIndex] : {};
    }
  },
  watch: {
    moduleData: {
      handler(val) {
        const currentLevelData = val.levelList[this.currentLevelIndex] || {};
        this.levelInfoList = currentLevelData.levelInfoList || [];
      },
      immediate: true
    }
  },

  mounted() {},

  methods: {
    handleAddModule() {
      this.$emit("onAdd");
    },
    // 模块更多操作
    handleMore(command, data) {
      if (command === "copy") {
        const moduleData = JSON.parse(JSON.stringify(this.moduleData));
        this.$emit("onCopy", moduleData);
      }
    },
    // 模块设置
    handleOpenModuleSetupPanel() {
      this.$refs.setupPanel.open();
    },
    handleChangeData(data) {
      this.$emit("onChange", data);
    },
    // 模块删除
    handleDeleteModule() {
      this.$emit("onDelete");
    },
    handleTitleChange(title) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.title = title;
      this.$emit("onChange", moduleData);
    },
    // 添加等级
    handleAddLevel() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      let index = moduleData.levelList.length - 1;
      const firstLevelList = moduleData.levelList[0];
      if (index < 0) index = 0;
      const lastLvelData = moduleData.levelList[index] || {
        level: 0,
        levelInfoList: []
      };
      moduleData.levelList.push({
        level: lastLvelData.level + 1,
        // 取第一个的levelInfoList作为内容
        levelInfoList: firstLevelList.levelInfoList
      });
      this.$emit("onChange", moduleData);
    },
    handleChangeLevelItem(index, level) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentLevelData = moduleData.levelList[index];
      moduleData.levelList.splice(index, 1, {
        ...currentLevelData,
        level
      });
      this.$emit("onChange", moduleData);
    },
    handleChangeLevel(levelList) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.levelList = levelList;
      this.$emit("onChange", moduleData);
    },
    handleChangeLabel(label) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.label = label;
      this.$emit("onChange", moduleData);
    },
    //
    handlePrevLevel() {
      if (this.currentLevelIndex === 0) return;
      this.currentLevelIndex--;
    },
    handleNextLevel() {
      if (this.moduleData.levelList && this.currentLevelIndex === this.moduleData.levelList.length - 1) return;
      this.currentLevelIndex++;
    },
    handleEditLevel(index) {
      this.currentLevelIndex = index;
    },
    handleDeleteLevel(index) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      if (moduleData.levelList.length == 1 && index === 0) {
        this.$alert("最后一项不能删除！");
        return;
      }
      moduleData.levelList.splice(index, 1);
      this.currentLevelIndex = index - 1 >= 0 ? index - 1 : 0;
      this.$emit("onChange", moduleData);
    },
    // levelInfo排序
    handleSortLevelInfo() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentLevelData = moduleData.levelList[this.currentLevelIndex];
      currentLevelData.levelInfoList = this.levelInfoList;
      this.$emit("onChange", moduleData);
    },
    // 编辑
    handleLevelInfoChange(dataIndex, data) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentLevelData = moduleData.levelList[this.currentLevelIndex];
      currentLevelData.levelInfoList.splice(dataIndex, 1, data);
      this.$emit("onChange", moduleData);
    },
    // 添加
    handleAddInfo(dataIndex = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentLevelData = moduleData.levelList[this.currentLevelIndex];
      // console.log(currentLevelData);
      currentLevelData.levelInfoList.splice(dataIndex + 1, 0, {
        key: Math.random().toString(16),
        title: "",
        content: ""
      });
      this.$emit("onChange", moduleData);
    },
    // 删除
    handleDeleteInfo(dataIndex = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentLevelData = moduleData.levelList[this.currentLevelIndex];
      currentLevelData.levelInfoList.splice(dataIndex, 1);
      this.$emit("onChange", moduleData);
    }
  }
};
</script>

<style lang="less" scoped>
.fight-info {
  width: 100%;
  .level {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #373737;
    margin-right: 10px;
  }
  .container {
    padding: 19px 24px 10px 24px;
    display: flex;
    flex-wrap: wrap;
    .item-box {
      margin-right: 30px;
      margin-bottom: 14px;
    }
  }

  .add-btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 3px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    &:hover {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
